import { render } from "./FrontendMobileAccountComponent.vue?vue&type=template&id=70512800"
import script from "./FrontendMobileAccountComponent.vue?vue&type=script&lang=js"
export * from "./FrontendMobileAccountComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/layouts/frontend/FrontendMobileAccountComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70512800"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70512800', __exports__)) {
    api.reload('70512800', __exports__)
  }
  
  module.hot.accept("./FrontendMobileAccountComponent.vue?vue&type=template&id=70512800", () => {
    api.rerender('70512800', render)
  })

}


export default __exports__